// AppErrorBoundary is used to catch any error or crash happens all the overs app, that's why it is used in the top most tree.
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";

interface StateInterface {
  hasError: boolean
}

interface PropsInterface {
  children: JSX.Element
}
class AppErrorBoundary extends React.Component<PropsInterface, StateInterface> {
  constructor(props: PropsInterface) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: any, info: any) {
    console.log('info:', info)
    console.log('error:', error)

    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service

    //TODO:
    // logErrorToMyService(error, info);
  }

  render() {
    // You can render any custom fallback UI
    return (<>
      {this.props.children}
      {this.state.hasError && <Dialog
        onClose={() => {
          this.setState({ hasError: false })
        }}
        open={true}
      >
        <DialogTitle>Oops!</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            We encountered an unexpected condition that prevented it from fulfilling the request. Please try again later.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            window.location.reload()
          }} >
            Ok
          </Button>
        </DialogActions>
      </Dialog>}
    </>);
  }
}

export default AppErrorBoundary;
